import { forwardRef, useId } from "react";
import type { IconsaxProps } from "./Iconsax.types.js";

export const InfoCircleBold = forwardRef<HTMLDivElement, IconsaxProps>(({ size = 24, color = "currentColor", ...rest }, ref) => {
    const clipId = useId();
    return (
        <div ref={ref} {...rest} style={{ display: "flex", width: "fit-content", alignItems: "center", justifyContent: "center", ...rest.style }}>
            <svg width={size} height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
                <g clipPath={`url(#${clipId})`}>
                    <path
                        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.47 17.52 2 12 2ZM11.99 6.29H12C12.55 6.29 13 6.74 13 7.29C13 7.84 12.55 8.29 12 8.29C11.45 8.29 10.99 7.84 10.99 7.29C10.99 6.74 11.44 6.29 11.99 6.29ZM14.19 16.89C14.11 17.23 13.8 17.46 13.46 17.46C13.4 17.46 13.34 17.45 13.28 17.44L12.82 17.32C11.88 17.09 11.23 16.25 11.23 15.28V11.44C11.23 11.15 11.03 10.91 10.75 10.85L10.4 10.78C9.98999 10.7 9.73 10.3 9.81 9.9C9.89 9.49 10.29 9.23001 10.69 9.31001L11.04 9.38C12.02 9.58 12.73 10.44 12.73 11.44V15.28C12.73 15.56 12.92 15.8 13.19 15.86L13.65 15.98C14.05 16.08 14.29 16.49 14.19 16.89Z"
                        fill="white"
                        style={{ fill: "var(--fillg)" }}
                    />
                </g>
                <defs>
                    <clipPath id={clipId}>
                        <rect width="24" height="24" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </div>
    );
});
